import React from 'react';
import { founder } from '../data/content';
export function FounderNote() {
  return <div className="border-t border-line" data-id="element-107" data-mp="2m86or4m1iaty">
      <div className="mx-auto flex max-w-content flex-col gap-5 px-4 py-7 md:flex-row md:items-start md:gap-7 md:px-8 md:py-9" data-id="element-108" data-mp="2m7wxldp9dxmo">
        <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-2xl bg-canvas md:h-[104px] md:w-[104px]" data-id="element-109" data-mp="28b1mzgtczy4i">
          <img src={founder.image} alt={`${founder.name}, ${founder.title} of HomeSmart NEXT`} loading="eager" decoding="async" className="absolute left-[-33%] top-0 w-[190%] max-w-none" data-id="element-110" data-mp="1yj4a85mpcy3o" />
        </div>

        <figure className="max-w-3xl" data-id="element-111" data-mp="1pg362ahedh2n">
          <blockquote className="font-display text-[16px] leading-[1.5] tracking-[-0.01em] text-ink md:text-[19px]" data-id="element-112" data-mp="1ugr6fmrina9j">
            &ldquo;{founder.quote}&rdquo;
          </blockquote>
          <figcaption className="mt-3 text-[13px] font-medium text-ink-400" data-id="element-113" data-mp="1kj36mif1zcki">
            <span className="text-ink" data-id="element-114" data-mp="1kl7etcjzixql">{founder.name}</span> — {founder.title}, {founder.company}
          </figcaption>
        </figure>
      </div>
    </div>;
}